import React, { useState, useEffect } from "react";
import styles from "../Carousel/Carousel.module.scss";
// import banner1 from "../../../assets/images/banner1.png";
// import banner2 from "../../../assets/images/banner2new.png";
// import banner3 from "../../../assets/images/banner3new.png";
// import banner4 from "../../../assets/images/banner4new.png";
// import banner5 from "../../../assets/images/banner5.png";
// import banner6 from '../../../assets/images/decadeOfExcellence.png';

import banner1 from "images/office-team-group.jpg";
import banner2 from "images/happy-job-offer.jpg";
import banner3 from "images/business-meeting-handshake.jpg";
import banner4 from "images/smart-glass-tech.jpg";
import banner5 from "images/office-meeting.jpg";
import banner6 from "images/corporate-team-strategy-discussion.jpg";

import bannerCenterImage from "../../../assets/images/CarouselBannerCenterImage.png";
import { useNavigate } from "react-router-dom";

const carouselData = [
  {
    heading:
      "<p class='bannerHeading' style='text-transform:uppercase;line-height:1.25131'><strong>Millions of careers.<br/> one unwavering mission.</strong><br/> Celebrating <span style='color:#DB6516'>4 decades</span> of aptech<p>",
    image: "/images/banner-4-decades-aptech.jpg",
    centerImage: bannerCenterImage,
    image_alt: "Celebrating 4 decades of aptech",
    image_title: "Celebrating 4 decades of aptech",
  },
  {
    heading:
      "<p class='bannerHeading'><strong>TRANSFORMING LIVES</strong> GLOBALLY THROUGH QUALITY EDUCATION <strong>SINCE 1986</strong><p>",
    image: "/images/office-team-group.jpg",
    centerImage: bannerCenterImage,
    image_alt: "Young Professional Team at Aptech Office",
    image_title: "Professional Group in Workspace",
  },
  {
    heading:
      "<p class='bannerHeading'><strong>100% PLACEMENT ASSISTANCE</strong></p><p class='bannerSubHeading'>Empanelled with Hundreds of Trusted Recruitment Partners</p>",
    image: "/images/happy-job-offer.jpg",
    centerImage: bannerCenterImage,
    image_alt: "Woman Smiling and Reading a Job Acceptance Letter",
    image_title: "Job Placement Assistance",
  },
  {
    heading:
      "<p class='bannerHeading'><strong>BUSINESS WITH A PURPOSE</strong></p><p class='bannerSubHeading'>Partner with Aptech in its Mission Towards a Skilled & Globalised Workforce</p>",
    image: "/images/business-meeting-handshake.jpg",
    centerImage: bannerCenterImage,
    image_alt: "Professionals Shaking Hands After Partnership Meeting",
    image_title: "Partnership Meeting",
  },
  {
    heading:
      "<p class='bannerHeading'><strong>BEST-IN CLASS</strong> QUALITY ASSESSMENT & TESTING SOLUTIONS ALIGNED TO THE <strong>VISION OF VIKSIT BHARAT</strong><p>",
    image: "/images/smart-glass-tech.jpg",
    centerImage: bannerCenterImage,
    image_alt: "Girl Using Futuristic Digital Screen",
    image_title: "Interacting With Futuristic Digital Screen",
  },
  {
    heading:
      "<p class='bannerHeading'><strong>CREATE A FUTURE-READY WORKFORCE</strong></p><p class='bannerSubHeading'>Through Industry-Aligned Skilling & Upskilling Programs for Educational Institutes & Corporates</p>",
    image: "/images/office-meeting.jpg",
    centerImage: bannerCenterImage,
    image_alt: "Team Applauding a Female Colleague During Office Meeting",
    image_title: "Upskilling Sessions for Corporates",
  },
  {
    heading:
      "<p class='bannerHeading'><strong>DECADES OF EXCELLENCE</strong></p><p class='bannerSubHeading'>Empowering Careers through Strategic Alliances with MESC, B&WSSC, CIDESCO, NSDC, NFDC, & many more</p>",
    image: "/images/corporate-team-strategy-discussion.jpg",
    centerImage: bannerCenterImage,
    image_alt: "Corporate Team engaged In Business Strategy Meeting",
    image_title: "Strategic Alliance Meeting",
  },
];

const Carousel: React.FC = () => {
  const isSmallScreen = window.innerWidth <= 992;
  const navigate = useNavigate();
  const [activeSlide, setActiveSlide] = useState(0);

  const handleIndicatorClick = (index: number) => {
    setActiveSlide(index);
  };

  useEffect(() => {
    const carouselElement = document.getElementById("carouselExampleControls");
    const handleSlideEvent = (e: any) => {
      setActiveSlide(Number(e.to));
    };

    carouselElement?.addEventListener("slide.bs.carousel", handleSlideEvent);

    return () => {
      carouselElement?.removeEventListener(
        "slide.bs.carousel",
        handleSlideEvent,
      );
    };
  }, []);

  return (
    <div className={`${styles.banner}`}>
      <div className="container">
        <div className={`row ${styles.mainDiv}`}>
          {/* LEFT SECTION (HEADINGS + BUTTON) */}
          <div className="col-xl-6 col-md-12 col-sm-12 col-12 d-flex flex-column justify-content-center">
            <p
              className={`${styles.courselHeading}`}
              dangerouslySetInnerHTML={{
                __html: carouselData[activeSlide].heading,
              }}
            ></p>

            {/* <p className={`${styles.courselHeading} heading`}>
              {carouselData[activeSlide].subHeading}
            </p> */}

            {!isSmallScreen && activeSlide === 1 && (
              <div className={`${styles.sideDiv} ${styles.exploreButtonDiv}`}>
                <button
                  className={`secondary-btn ${styles.exploreButton}`}
                  onClick={() => navigate("/our-businesses")}
                  style={{ width: "auto" }}
                >
                  Explore Our Brands
                </button>
              </div>
            )}
            {!isSmallScreen && activeSlide === 3 && (
              <div className={`${styles.sideDiv} ${styles.exploreButtonDiv}`}>
                <button
                  className={`secondary-btn ${styles.exploreButton}`}
                  onClick={() => navigate("/partner-with-aptech")}
                  style={{ width: "auto" }}
                >
                  Partner With Us
                </button>
              </div>
            )}
          </div>

          {/* RIGHT SECTION (CAROUSEL) */}
          <div className="col-xl-6 col-md-12 col-sm-12 col-12 d-flex flex-column justify-content-center">
            <div
              id="carouselExampleControls"
              className={`carousel slide ${styles.carouselSlide}`}
              data-bs-ride="carousel"
            >
              <div className={`carousel-inner ${styles["carousel-inner"]}`}>
                {carouselData.map((slide, index) => (
                  <div
                    key={index}
                    className={`carousel-item ${index === 0 ? "active" : ""} ${styles["carousel-item"]}`}
                  >
                    <div
                      className={`d-flex justify-content-center align-items-center ${styles.caourselContentDiv}`}
                    >
                      <div className={`${styles["caourselContent"]} container`}>
                        <div>
                          <div className={styles.sideDiv}></div>
                          <div className={`${styles.bannerBox}`}>
                            <img
                              src={slide.image}
                              className={styles.bannerImageStyle}
                              alt={slide.image_alt}
                              title={slide.image_title}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}

                {/* Indicators */}
                <div className={`${styles["carousel-indicators"]}`}>
                  {carouselData.map((_, index) => (
                    <button
                      key={index}
                      type="button"
                      data-bs-target="#carouselExampleControls"
                      data-bs-slide-to={index}
                      className={`${styles["indicator-button"]} ${activeSlide === index ? styles.active : ""}`}
                      onClick={() => handleIndicatorClick(index)}
                      aria-current={activeSlide === index ? "true" : undefined}
                      aria-label={`Slide ${index + 1}`}
                    ></button>
                  ))}
                </div>
              </div>
            </div>

            {/* Button for small screen below carousel */}
            {isSmallScreen && activeSlide === 1 && (
              <div
                className={`${styles.sideDiv} ${styles.exploreButtonDiv} d-flex justify-content-center align-items-center`}
              >
                <button
                  className={`secondary-btn ${styles.exploreButton}`}
                  onClick={() => navigate("/our-businesses")}
                  style={{ width: "auto" }}
                >
                  Explore Our Brands
                </button>
              </div>
            )}
            {isSmallScreen && activeSlide === 3 && (
              <div
                className={`${styles.sideDiv} ${styles.exploreButtonDiv} d-flex justify-content-center align-items-center`}
              >
                <button
                  className={`secondary-btn ${styles.exploreButton}`}
                  onClick={() => navigate("/partner-with-aptech")}
                  style={{ width: "auto" }}
                >
                  Partner With Us
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Carousel;
